<template>
  <div class="question-answer">
    <!-- MultiChoice, Dropdown Question Types -->
    <div
      v-if="['MultiChoice', 'Dropdown'].includes(this.questionType)"
      class="multiple-choice"
    >
      <div v-if="!preview" class="add-btn" @click="addAnswerItem">
        <span class="add-circle">
          <md-icon>add</md-icon>
        </span>
        <div class="label">Thêm câu trả lời</div>
      </div>

      <div class="answers md-layout md-gutter">
        <div
          class="answer md-layout-item md-size-50 answer-item"
          v-for="(ans, index) in answersTemp"
          :key="index"
        >
          <md-radio
            v-model="rightTemp"
            :value="index"
            :disabled="preview"
            @change="updateRightAnswerToParent"
          />
          <BaseInputQuestionRichText
            v-model="answersTemp[index]"
            :suffixIcon="preview ? '' : 'delete'"
            :disabled="preview"
            :label="label"
            @update="updateAnswersToParent"
            @clickSuffixIcon="deleteAnswerItem(index)"
          />
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="answersTemp[studentAnswer.answer]"
        ></div>
      </div>
    </div>

    <!-- MultiSelect Question Type -->
    <div v-if="this.questionType === 'MultiSelect'" class="multi-select">
      <div v-if="!preview" class="add-btn" @click="addAnswerItem">
        <span class="add-circle">
          <md-icon>add</md-icon>
        </span>
        <div class="label">Thêm câu trả lời</div>
      </div>

      <div class="answers md-layout md-gutter">
        <div
          class="answer md-layout-item md-size-50 answer-item"
          v-for="(ans, index) in answersTemp"
          :key="index"
        >
          <md-checkbox
            :value="true"
            v-model="rightTemp[index]"
            :disabled="preview"
            @change="handleMultiSelectChange(index, $event)"
          />
          <BaseInputQuestionRichText
            v-model="answersTemp[index]"
            :suffixIcon="preview ? '' : 'delete'"
            :disabled="preview"
            :label="label"
            @update="updateAnswersToParent"
            @clickSuffixIcon="deleteAnswerItem(index)"
          />
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div style="padding-left: 15px">
          <div
            v-for="(ansIndex, idx) in studentAnswer.answer"
            :key="idx"
            :style="
              rightTemp && rightTemp[ansIndex] === true
                ? 'color: #28a745'
                : 'color: #c82333'
            "
            v-html="answersTemp[ansIndex]"
          ></div>
        </div>
      </div>
    </div>

    <div v-if="this.questionType === 'ShortAnswer'" class="short-answer">
      <div v-if="!preview" class="add-btn" @click="addRightAnswerItem">
        <span class="add-circle">
          <md-icon>add</md-icon>
        </span>
        <div class="label">Thêm câu trả lời</div>
      </div>

      <div class="answers md-layout md-gutter">
        <div
          class="answer md-layout-item md-size-50 answer-item"
          v-for="(ans, index) in rightTemp"
          :key="index"
        >
          <BaseInputQuestionText
            v-model="rightTemp[index]"
            :suffixIcon="preview ? '' : 'delete'"
            :disabled="preview"
            @update="updateRightAnswerToParent"
            @clickSuffixIcon="deleteRightAnswerItem(index)"
          />
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <div v-if="this.questionType === 'StringSorting'" class="string-sorting">
      <div class="answers">
        <div class="answer answer-item">
          <BaseInputQuestionText
            v-model="rightTemp"
            :disabled="preview"
            @update="updateRightAnswerToParent"
          />
        </div>

        <div class="note" style="padding-top: 14px; font-size: 12px">
          <span style="font-weight: bold">Chú ý: </span> Nhập vào một từ(không
          chứa dấu cách) hoặc một câu đáp án, EasySchool sẽ tự động trộn chữ
          cái(nếu là 1 từ) hoặc các từ (nếu là 1 câu). Học sinh sẽ phải sắp xếp
          các chữ cái, từ để tạo thành từ, câu đúng.
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <div v-if="this.questionType === 'Speaking'" class="speaking">
      <div class="answers">
        <div class="answer answer-item">
          <BaseInputQuestionText
            v-model="rightTemp"
            :disabled="preview"
            @update="updateRightAnswerToParent"
          />
        </div>

        <div class="note" style="padding-top: 14px; font-size: 12px">
          <span style="font-weight: bold">Chú ý: </span> Nhập vào một từ hoặc
          câu để học sinh nói phát âm từ hoặc câu đó.
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <div
      v-if="this.questionType === 'CompleteSentence'"
      class="complete-sentence"
    >
      <div class="answers">
        <div v-if="!preview" style="width: 100%">
          <BaseInputQuestionText
            v-model="answersTemp.phrase"
            label="Nhập vào câu cần hoàn thành"
            style="margin-bottom: 12px"
          />
        </div>
        <div class="answer answer-item">
          <div class="tag-list">
            <template
              v-for="(item, index) in splitIntoWords(answersTemp?.phrase)"
            >
              <div :key="index">
                <template v-if="rightTemp.includes(index)">
                  <el-tooltip placement="top" effect="light">
                    <template #content>
                      <span
                        class="complete-sentence-tag"
                        style="
                          background-color: #1cab36;
                          color: white;
                          margin-right: 5px;
                        "
                        >{{ item }}</span
                      >
                      <span
                        :key="index"
                        class="complete-sentence-tag"
                        style="
                          background-color: #ff5252;
                          color: white;
                          margin-right: 5px;
                        "
                      >
                        {{ fakeChoicesTemp[index] }}
                      </span>
                    </template>
                    <div
                      class="classification-tag"
                      style="
                        background-color: #ff8e1d;
                        color: white;
                        cursor: pointer;
                      "
                      @click="
                        !preview
                          ? handleSelectCompleteSentenceItem(index, item)
                          : null
                      "
                    >
                      <svg-icon icon-class="question-circle" />
                    </div>
                  </el-tooltip>
                </template>
                <template v-else>
                  <span
                    class="classification-tag"
                    style="margin-right: 5px"
                    @click="
                      !preview
                        ? handleSelectCompleteSentenceItem(index, item)
                        : null
                    "
                    >{{ item }}</span
                  >
                </template>
              </div>
            </template>
          </div>
        </div>

        <div
          v-if="!preview"
          class="note"
          style="padding-top: 14px; font-size: 12px"
        >
          <span style="font-weight: bold">Chú ý: </span>Chọn từ và nhập một đáp
          án sai để học sinh lựa chọn giữa 2 đáp án là từ bạn chọn và đáp án sai
          bạn nhập.
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == answersTemp.phrase.split(' ')[rightTemp[0]]
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <div v-if="this.questionType === 'Classification'" class="classification">
      <div v-if="!preview" class="add-btn">
        <span class="add-circle">
          <md-icon>add</md-icon>
        </span>
        <div class="label">Thêm trường</div>
      </div>

      <div class="answers md-layout md-gutter">
        <div class="classification-fields md-layout-item answer-item">
          <div
            v-if="preview"
            style="
              margin-left: 20px;
              padding-left: 16px;
              padding-right: 16px;
              cursor: not-allowed;
              background: rgba(0, 0, 0, 0.05);
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              padding-top: 4px;
              padding-bottom: 4px;
            "
          >
            <el-tag
              type="info"
              v-for="item in answersTemp.classificationFields"
              style="margin-right: 8px"
              :key="isNil(item[select1]) ? item : item[select1]"
              v-html="item"
            ></el-tag>
          </div>
          <BaseInputQuestionSelect
            key="select1"
            v-model="answersTemp.classificationFields"
            :multiple="true"
            :allowCreate="true"
            :filterable="true"
            :createTag="true"
            :disabled="preview"
            v-else
            style="width: 100%"
            @update="handleUpdateClassificationAnswer('classificationFields')"
          />
        </div>
      </div>

      <div v-if="!preview" class="add-btn">
        <span class="add-circle">
          <md-icon>add</md-icon>
        </span>
        <div class="label">Thêm đáp án</div>
      </div>

      <div class="answers md-layout md-gutter">
        <div class="classification-fields md-layout-item answer-item">
          <div
            v-if="preview"
            style="
              margin-left: 20px;
              padding-left: 16px;
              padding-right: 16px;
              cursor: not-allowed;
              background: rgba(0, 0, 0, 0.05);
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              padding-top: 4px;
              padding-bottom: 4px;
            "
          >
            <el-tag
              type="info"
              v-for="item in answersTemp.list"
              style="margin-right: 8px"
              :key="isNil(item[select2]) ? item : item[select2]"
              v-html="item"
            ></el-tag>
          </div>
          <BaseInputQuestionSelect
            key="select2"
            v-model="answersTemp.list"
            :multiple="true"
            :allowCreate="true"
            :filterable="true"
            :createTag="true"
            :disabled="preview"
            v-else
            style="width: 100%"
            @update="handleUpdateClassificationAnswer('classificationList')"
          />
        </div>
      </div>

      <div v-if="!preview" class="add-btn">
        <span class="add-circle">
          <md-icon>add</md-icon>
        </span>
        <div class="label">Đáp án đúng</div>
      </div>

      <div class="answers">
        <div
          class="classification-fields answer-item"
          v-for="(item, index) in answersTemp.classificationFields"
          :key="`classification-item-${index}`"
        >
          <span class="tag-list"
            ><span class="classification-tag" v-html="item"></span
          ></span>
          <div
            v-if="preview"
            style="
              margin-left: 20px;
              padding-left: 16px;
              padding-right: 16px;
              cursor: not-allowed;
              background: rgba(0, 0, 0, 0.05);
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              padding-top: 4px;
              padding-bottom: 4px;
            "
          >
            <el-tag
              type="info"
              v-for="item in answersTemp.list
                ? answersTemp.list.map((ans, index) => {
                    return { _id: index, name: ans }
                  })
                : []"
              style="margin-right: 8px"
              :key="item._id"
              v-html="item.name"
            ></el-tag>
          </div>
          <BaseInputQuestionSelect
            v-model="rightTemp[index]"
            :multiple="true"
            :allowCreate="false"
            :filterable="true"
            :createTag="true"
            :disabled="preview"
            v-else
            :options="
              answersTemp.list
                ? answersTemp.list.map((ans, index) => {
                    return { _id: index, name: ans }
                  })
                : []
            "
            style="width: 100%"
            @update="handleUpdateClassificationAnswer('classificationRight')"
          />
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <div v-if="this.questionType === 'UnderlineWord'" class="underline-word">
      <div class="answers">
        <div
          class="answer answer-item"
          style="display: flex; align-items: center"
        >
          <BaseInputQuestionSelect
            key="underline-type"
            v-model="answersTemp.type"
            :disabled="preview"
            :options="[
              {
                _id: 'word',
                name: 'Từ'
              },
              {
                _id: 'character',
                name: 'Chữ cái'
              }
            ]"
            label="Dạng gạch chân"
            @update="handleUpdateUnderlineWordAnswer('underlineType')"
            style="padding-right: 24px"
          />

          <BaseInputQuestionText
            v-model="answersTemp.phrase"
            :disabled="preview"
            label="Nhập vào từ hoặc cụm từ"
            @update="handleUpdateUnderlineWordAnswer('underlinePhrase')"
          />
        </div>

        <div
          v-if="answersTemp.type === 'word' && answersTemp.phrase"
          class="answer answer-item underline-right"
        >
          <span
            class="underline-tag"
            v-for="(item, index) in answersTemp.phrase.split(' ')"
            :key="`underline-tag-${index}`"
            :class="rightTemp.includes(index) ? 'selected' : ''"
            @click="handleSelectUnderlineWordTag(index)"
          >
            {{ item }}
          </span>
        </div>

        <div
          v-if="answersTemp.type === 'character' && answersTemp.phrase"
          class="answer answer-item underline-right"
        >
          <span
            class="underline-tag"
            v-for="(item, index) in answersTemp.phrase.split('')"
            :key="`underline-tag-${index}`"
            :class="rightTemp.includes(index) ? 'selected' : ''"
            @click="handleSelectUnderlineWordTag(index)"
          >
            {{ item }}
          </span>
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <div v-if="this.questionType === 'Matching' || this.questionType === 'Duo'" class="matching">
      <div v-if="!preview" class="add-btn" @click="handleAddMatchingAnswerItem">
        <span class="add-circle">
          <md-icon>add</md-icon>
        </span>
        <div class="label">Thêm đáp án</div>
      </div>

      <div class="answers md-layout md-gutter" style="padding-bottom: 12px">
        <div class="md-layout-item md-size-40 col-header">Cột A</div>
        <div class="md-layout-item md-size-40 col-header">Cột B</div>
      </div>

      <div
        v-for="(item, index) in rightTemp"
        :key="index"
        class="md-layout md-gutter"
      >
        <div class="matching-fields md-layout-item md-size-45 answer-item">
          <img
            v-if="preview && isImgUrl(answersTemp.classificationFields[index])"
            :src="answersTemp.classificationFields[index] | media"
          />
          <BaseInputQuestionFile
            accept="image/*"
            :labelSize="16"
            :disabled="preview"
            v-model="answersTemp.classificationFields[index]"
            iconClass="image"
            :storageClass="config.storageClass"
            :loading.sync="uploadLoading.answersTemp[index.toString()]"
            style="width: 100%"
            v-else
            @file-selected="
              (val) => {
                handleUpload('answersTemp', 'classificationFields', index, val)
              }
            "
            @clear="clearFile('answersTemp', 'classificationFields', index)"
            @update="updateAnswersToParent"
          />
        </div>

        <div
          class="classification-fields md-layout-item md-size-45 answer-item"
        >
          <img
            v-if="preview && isImgUrl(rightTemp[index])"
            :src="rightTemp[index] | media"
          />
          <BaseInputQuestionFile
            accept="image/*"
            :labelSize="16"
            :disabled="preview"
            v-model="rightTemp[index]"
            iconClass="image"
            style="width: 100%"
            :storageClass="config.storageClass"
            :loading.sync="uploadLoading.rightTemp[index.toString()]"
            v-else
            @file-selected="
              (val) => {
                handleUpload('rightTemp', '', index, val)
              }
            "
            @clear="clearFile('rightTemp', '', index)"
            @update="updateRightAnswerToParent"
          />
        </div>

        <div
          v-if="!preview"
          class="classification-fields md-layout-item md-size-10 answer-item"
          style="text-align: right"
        >
          <span
            @click="handleRemoveMatchingAnswerItem(index)"
            style="padding: 4px"
          >
            <md-icon>delete</md-icon>
          </span>
        </div>
      </div>

      <div class="note" style="padding-top: 32px; font-size: 12px">
        <span style="font-weight: bold">Chú ý: </span> Nhập vào đáp án đúng nối
        tương ứng với hàng ở cột A và B. Khi học sinh làm bài EasySchool sẽ tự
        động trộn đáp án ở cột A và B cho học sinh làm bài.
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <div v-if="this.questionType === 'MultiMatching'" class="multi-matching">
      <!-- Options Pool -->
      <div style="margin-bottom: 24px; border: 1px solid #ddd; padding: 16px; border-radius: 4px;">
        <div style="font-weight: bold; margin-bottom: 8px;">Nhóm B (Kho Lựa Chọn)</div>
        <div v-if="!preview" class="add-btn" @click="handleAddMultiMatchingPoolItem">
          <span class="add-circle"><md-icon>add</md-icon></span>
          <div class="label">Thêm lựa chọn</div>
        </div>
        <div v-for="(item, index) in answersTemp.list" :key="'pool-'+index" class="md-layout md-gutter" style="margin-bottom: 8px; align-items: center;">
          <div class="md-layout-item md-size-80">
            <BaseInputQuestionFile accept="image/*" :labelSize="16" :disabled="preview" v-model="answersTemp.list[index]" iconClass="image" :storageClass="config.storageClass" :loading.sync="(uploadLoading.answersList || {})[index.toString()]" style="width: 100%" @file-selected="(val) => { handleUpload('answersTemp', 'list', index, val) }" @clear="clearFile('answersTemp', 'list', index)" @update="updateAnswersToParent" />
          </div>
          <div v-if="!preview" class="md-layout-item md-size-10" style="text-align: right">
            <span @click="handleRemoveMultiMatchingPoolItem(index)" style="padding: 4px; cursor: pointer;"><md-icon>delete</md-icon></span>
          </div>
        </div>
      </div>

      <!-- Targets -->
      <div style="border: 1px solid #ddd; padding: 16px; border-radius: 4px;">
        <div style="font-weight: bold; margin-bottom: 8px;">Nhóm A (Câu Hỏi)</div>
        <div v-if="!preview" class="add-btn" @click="handleAddMultiMatchingTargetItem">
          <span class="add-circle"><md-icon>add</md-icon></span>
          <div class="label">Thêm câu hỏi</div>
        </div>
        <div v-for="(item, index) in answersTemp.classificationFields" :key="'target-'+index" class="md-layout md-gutter" style="margin-bottom: 8px; align-items: center;">
          <div class="md-layout-item md-size-40">
            <BaseInputQuestionFile accept="image/*" :labelSize="16" :disabled="preview" v-model="answersTemp.classificationFields[index]" iconClass="image" :storageClass="config.storageClass" :loading.sync="(uploadLoading.answersTemp || {})[index.toString()]" style="width: 100%" @file-selected="(val) => { handleUpload('answersTemp', 'classificationFields', index, val) }" @clear="clearFile('answersTemp', 'classificationFields', index)" @update="updateAnswersToParent" />
          </div>
          <div class="md-layout-item md-size-10" style="text-align: center;">→</div>
          <div class="md-layout-item md-size-40">
            <select v-model="rightTemp[index]" @change="updateRightAnswerToParent" :disabled="preview" style="width: 100%; padding: 8px; border-radius: 4px; border: 1px solid #ccc;">
              <option :value="undefined" disabled>Chọn đáp án</option>
              <option v-for="(opt, oIndex) in answersTemp.list" :key="'opt-'+oIndex" :value="oIndex">
                Lựa chọn {{ oIndex + 1 }} ({{ (opt || '').substring(0, 20) }}{{ (opt || '').length > 20 ? '...' : '' }})
              </option>
            </select>
          </div>
          <div v-if="!preview" class="md-layout-item md-size-10" style="text-align: right">
            <span @click="handleRemoveMultiMatchingTargetItem(index)" style="padding: 4px; cursor: pointer;"><md-icon>delete</md-icon></span>
          </div>
        </div>
      </div>
      <div class="note" style="padding-top: 16px; font-size: 12px">
        <span style="font-weight: bold">Chú ý: </span> MultiMatching cho phép gán 1 lựa chọn từ Nhóm B vào nhiều câu hỏi ở Nhóm A.
      </div>
      <div v-if="studentAnswer" class="answer md-layout-item md-size-100 answer-item">
        <strong>Câu trả lời của học sinh: </strong>
        <div style="padding-left: 15px">
          <div v-for="(ans, aIdx) in studentAnswer.answer" :key="'stu-ans-'+aIdx">
            {{ aIdx + 1 }}. <span :style="ans === answersTemp.list[rightTemp[aIdx]] ? 'color: #28a745' : 'color: #c82333'">{{ ans }}</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="this.questionType === 'WordSearch'" class="word-search">
      <div class="letter-table" style="padding: 0 24px 24px">
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-30">
            <BaseInputQuestionText
              v-model="answersTemp.w"
              :disabled="preview"
              label="Số hàng"
              type="number"
              style="padding-bottom: 12px"
              @update="handleChangeCrosswordSize"
            />

            <BaseInputQuestionText
              v-model="answersTemp.h"
              :disabled="preview"
              label="Số cột"
              type="number"
              @update="handleChangeCrosswordSize"
            />
          </div>
          <div class="md-layout-item md-size-70">
            <div
              v-if="
                answersTemp.w > 0 && answersTemp.h > 0 && answersTemp.crossword
              "
            >
              <div
                v-for="(col, colIdx) in Number(answersTemp.h)"
                :key="`crossword-col-${colIdx}`"
                class="crossword-row"
              >
                <span
                  v-for="(row, rowIdx) in Number(answersTemp.w)"
                  :key="`crossword-row-${rowIdx}`"
                >
                  <BaseInputQuestionText
                    v-model="answersTemp.crossword[colIdx][rowIdx]"
                    class="crossword-unit"
                    :disabled="preview"
                    style="
                      border: 1px solid rgba(0, 0, 0, 0.1) !important;
                      width: 42px;
                      height: 42px !important;
                      border-radius: 0 !important;
                    "
                    customStyle="width: 42px; height: 42px !important; padding: 4px !important; border-radius: 0 !important; text-align: center"
                    @update="updateAnswersToParent"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!preview" class="add-btn" @click="addRightAnswerItem">
        <span class="add-circle">
          <md-icon>add</md-icon>
        </span>
        <div class="label">Thêm câu đáp án đúng</div>
      </div>

      <div class="answers md-layout md-gutter">
        <div
          class="answer md-layout-item md-size-50 answer-item"
          v-for="(ans, index) in rightTemp"
          :key="index"
        >
          <BaseInputQuestionText
            v-model="rightTemp[index]"
            :suffixIcon="preview ? '' : 'delete'"
            :disabled="preview"
            @update="updateRightAnswerToParent"
            @clickSuffixIcon="deleteRightAnswerItem(index)"
          />
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- DaDImageLabeling Question Type -->
    <!-- ============================================ -->
    <div
      v-if="this.questionType === 'DaDImageLabeling'"
      class="dad-image-labeling"
    >
      <div
        v-if="!preview"
        class="add-btn"
        @click="handleShowDadLabelDialog(-1)"
      >
        <span class="add-circle">
          <md-icon>add</md-icon>
        </span>
        <div class="label">Thêm nhãn</div>
      </div>

      <!-- Image preview with labels -->
      <div v-if="questionImageUrl" class="dad-image-container">
        <div class="image-wrapper">
          <img
            :src="questionImageUrl | media"
            alt="Labeling Image"
            class="dad-image"
          />
          <div
            v-for="(item, index) in rightTemp"
            :key="`label-${index}`"
            class="label-rect"
            :style="{
              left: item.x + '%',
              top: item.y + '%',
              width: item.w + '%',
              height: item.h + '%'
            }"
          >
            <span class="label-text">{{ item.label }}</span>
            <div v-if="!preview" class="label-actions">
              <el-button
                type="text"
                size="small"
                @click="handleShowDadLabelDialog(index)"
              >
                <svg-icon icon-class="edit" />
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="handleDeleteDadLabel(index)"
              >
                <svg-icon icon-class="trash" />
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <!-- ============================================ -->
    <!-- FillInTheBlanks Question Type -->
    <!-- ============================================ -->
    <div v-if="this.questionType === 'FillInTheBlanks'" class="fill-in-blanks">
      <!-- Edit mode -->
      <div v-if="!preview" class="fill-blanks-editor">
        <div class="toolbar">
          <el-button type="primary" size="small" @click="handleInsertBlank">
            Chèn chỗ trống
          </el-button>
          <el-button
            size="small"
            @click="handleInsertNewLine"
            style="margin-left: 8px"
          >
            Xuống dòng
          </el-button>
        </div>

        <div class="editor-split">
          <div class="editor-left">
            <div class="section-title">Nội dung</div>
            <el-input
              ref="fillBlanksTextRef"
              type="textarea"
              v-model="answersTemp"
              :rows="6"
              placeholder="Nhập nội dung câu hỏi. Sử dụng nút 'Chèn chỗ trống' để thêm [[]] và 'Xuống dòng' để thêm |n|"
              @input="handleFillBlanksTextChange"
              @blur="handleSaveCursorPosition"
              @keyup.native="handleSaveCursorPosition"
              @click.native="handleSaveCursorPosition"
            />
          </div>
          <div class="editor-right">
            <div class="section-title">Xem trước</div>
            <div class="preview-content">
              <div
                v-for="(lineParts, lineIndex) in getFillBlanksPreviewParts()"
                :key="`preview-line-${lineIndex}`"
                class="preview-line"
              >
                <span
                  v-for="(part, partIndex) in lineParts"
                  :key="`part-${lineIndex}-${partIndex}`"
                  class="part-wrapper"
                >
                  <span class="text-part">{{ part }}</span>
                  <span
                    v-if="partIndex < lineParts.length - 1"
                    class="blank-slot"
                  >
                    <span class="blank-number">{{
                      getGlobalBlankIndex(lineIndex, partIndex) + 1
                    }}</span>
                    <el-button
                      type="text"
                      size="small"
                      class="delete-blank-btn"
                      @click="
                        handleDeleteBlank(
                          getGlobalBlankIndex(lineIndex, partIndex)
                        )
                      "
                    >
                      <svg-icon icon-class="trash" />
                    </el-button>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="blanks-answers" v-if="rightTemp && rightTemp.length > 0">
          <div class="blanks-title">Các đáp án cho từng chỗ trống:</div>
          <div
            v-for="(blankAnswers, blankIndex) in rightTemp"
            :key="`blank-${blankIndex}`"
            class="blank-answer-item"
          >
            <span class="blank-label">Chỗ trống {{ blankIndex + 1 }}:</span>
            <el-select
              :value="blankAnswers"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="Nhập các đáp án chấp nhận (nhấn Enter để thêm)"
              style="flex: 1"
              @change="(val) => handleUpdateBlankAnswer(blankIndex, val)"
            >
              <el-option
                v-for="item in blankAnswers"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
      </div>

      <!-- Preview mode -->
      <div v-else class="fill-blanks-preview">
        <div
          v-for="(lineParts, lineIndex) in getFillBlanksPreviewParts()"
          :key="`line-${lineIndex}`"
          class="preview-line"
        >
          <span
            v-for="(part, partIndex) in lineParts"
            :key="`part-${lineIndex}-${partIndex}`"
            class="part-wrapper"
          >
            <span class="text-part">{{ part }}</span>
            <span v-if="partIndex < lineParts.length - 1" class="blank-slot">
              {{ getBlankAnswerDisplay(lineIndex, partIndex) }}
            </span>
          </span>
        </div>
      </div>
      <div
        v-if="studentAnswer"
        class="answer md-layout-item md-size-100 answer-item"
      >
        <strong>Câu trả lời của học sinh: </strong>
        <div
          style="padding-left: 15px"
          :style="
            studentAnswer.answer == rightTemp
              ? 'color: #28a745'
              : 'color: #c82333'
          "
          v-html="studentAnswer.answer"
        ></div>
      </div>
    </div>

    <!-- Add/Edit Label Dialog for DaDImageLabeling -->
    <el-dialog
      :title="dadLabelEditIndex >= 0 ? 'Chỉnh sửa nhãn' : 'Thêm nhãn mới'"
      :visible.sync="dadLabelDialogVisible"
      width="80%"
      append-to-body
      :destroy-on-close="true"
    >
      <div class="dad-label-dialog">
        <el-form label-position="top">
          <el-form-item label="Tên nhãn" required>
            <el-input
              v-model="dadLabelForm.label"
              placeholder="Nhập tên nhãn"
            />
          </el-form-item>

          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="X (%)">
                <el-input-number
                  v-model="dadLabelForm.x"
                  :min="0"
                  :max="100"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Y (%)">
                <el-input-number
                  v-model="dadLabelForm.y"
                  :min="0"
                  :max="100"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Width (%)">
                <el-input-number
                  v-model="dadLabelForm.w"
                  :min="1"
                  :max="100"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Height (%)">
                <el-input-number
                  v-model="dadLabelForm.h"
                  :min="1"
                  :max="100"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item
            label="Chọn vùng trên ảnh (kéo chuột để vẽ hình chữ nhật)"
          >
            <div class="dialog-image-container" v-if="questionImageUrl">
              <div
                class="dialog-image-wrapper"
                @mousedown="handleImageMouseDown"
                @mousemove="handleImageMouseMove"
                @mouseup="handleImageMouseUp"
                @mouseleave="handleImageMouseUp"
              >
                <img
                  ref="dadImageRef"
                  :src="questionImageUrl | media"
                  alt="Select area"
                  class="dialog-image"
                  draggable="false"
                />
                <!-- Show other existing labels -->
                <div
                  v-for="(item, index) in rightTemp"
                  :key="`other-label-${index}`"
                  class="other-label-rect"
                  :class="{ 'current-editing': index === dadLabelEditIndex }"
                  :style="{
                    left: item.x + '%',
                    top: item.y + '%',
                    width: item.w + '%',
                    height: item.h + '%'
                  }"
                >
                  <span class="other-label-text">{{ item.label }}</span>
                </div>
                <!-- Current selection rectangle -->
                <div
                  class="selection-rect"
                  :style="{
                    left: dadLabelForm.x + '%',
                    top: dadLabelForm.y + '%',
                    width: dadLabelForm.w + '%',
                    height: dadLabelForm.h + '%'
                  }"
                />
              </div>
            </div>
            <div v-else class="no-image-notice">
              <el-alert
                title="Vui lòng thêm URL ảnh vào câu hỏi trước"
                type="warning"
                :closable="false"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dadLabelDialogVisible = false">Hủy</el-button>
        <el-button type="primary" @click="handleSaveDadLabel"
          >Xác nhận</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="Nhập đán án sai"
      :visible.sync="completeSentenceDialog"
      width="30%"
      append-to-body
      center
    >
      <div class="dialog-content" v-if="questionType === 'CompleteSentence'">
        <BaseInputQuestionText
          v-model="fakeChoicesTemp[rightTemp[0]]"
          label="Nhập đáp án sai"
        />

        <div style="text-align: right; padding-top: 12px">
          <el-button type="primary" @click="handleSaveFakeChoice"
            >Xác nhận</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import examVaultApi from '@/api/exam-vault'
import { mapGetters } from 'vuex'

export default {
  components: {},
  props: {
    questionImageUrl: {
      type: [String, null],
      default: null
    },
    answers: {
      type: [Array, Object, String],
      default: () => []
    },
    rightAnswer: {
      type: [Number, String, Array],
      default: () => ''
    },
    fakeChoices: {
      type: Object,
      default: () => {}
    },
    questionType: {
      type: String,
      default: () => ''
    },
    preview: {
      type: Boolean,
      default: false
    },
    studentAnswer: {
      type: Object,
      default: () => {}
    },
    label: {
      type: String,
      default: () => ''
    },
    examVaultId: {
      type: String,
      default: () => null
    }
  },
  computed: {
    ...mapGetters(['eClass', 'config', 'googleDrive'])
  },
  data() {
    return {
      rightTemp: '',
      answersTemp: '',
      fakeChoicesTemp: {},
      uploadLoading: {
        answersTemp: {},
        rightTemp: {}
      },
      completeSentenceDialog: false,
      // DaDImageLabeling state
      dadLabelDialogVisible: false,
      dadLabelEditIndex: -1,
      dadLabelForm: {
        label: '',
        x: 0,
        y: 0,
        w: 10,
        h: 10
      },
      isDrawing: false,
      drawStart: { x: 0, y: 0 },
      // FillInTheBlanks state
      fillBlanksCursorPos: null
    }
  },
  watch: {
    rightAnswer: {
      handler() {
        let rightValue = _.cloneDeep(this.rightAnswer)

        // Convert array to object for MultiSelect
        if (this.questionType === 'MultiSelect' && Array.isArray(rightValue)) {
          const objValue = {}
          rightValue.forEach((index) => {
            objValue[index] = true
          })
          rightValue = objValue
        }

        this.rightTemp = rightValue
      },
      immediate: true,
      deep: true
    },
    answers: {
      handler(val) {
        this.answersTemp = _.cloneDeep(val)
      },
      immediate: true,
      deep: true
    },
    fakeChoices: {
      handler(val) {
        this.fakeChoicesTemp = _.cloneDeep(val)
      },
      immediate: true,
      deep: true
    }
  },
  created() {},
  methods: {
    isNil(val) {
      return _.isNil(val)
    },
    isImgUrl(value) {
      if (value.endsWith('&ggdrive')) {
        return true
      }

      const lowerValue = value.toLowerCase()
      return (
        lowerValue.endsWith('.png') ||
        lowerValue.endsWith('.jpg') ||
        lowerValue.endsWith('.jpeg') ||
        lowerValue.endsWith('.tiff') ||
        lowerValue.endsWith('.gif')
      )
    },
    splitIntoWords(phrase) {
      return phrase?.split(' ') || []
    },
    handleSaveFakeChoice() {
      if (
        !this.fakeChoicesTemp[this.rightTemp[0]] ||
        this.fakeChoicesTemp[this.rightTemp[0]] === ''
      ) {
        this.$notify({
          type: 'warning',
          title: 'Lỗi',
          message: 'Vui lòng nhập đáp án sai.'
        })
        return
      }

      this.updateAnswersToParent()
      this.updateRightAnswerToParent()
      this.updateFakeChoiceToParent()

      this.completeSentenceDialog = false
    },

    handleSelectCompleteSentenceItem(index, item) {
      if (this.preview) {
        return
      }

      const fakeChoice =
        index === this.rightTemp[0] ? this.fakeChoicesTemp[index] : ''
      this.rightTemp = [index]
      this.fakeChoicesTemp = {
        [index]: fakeChoice
      }
      this.completeSentenceDialog = true
    },

    handleChangeCrosswordSize() {
      this.resetCrossword()
      this.updateAnswersToParent()
    },

    resetCrossword() {
      this.answersTemp.crossword = []
      for (let i = 0; i < this.answersTemp.h; i++) {
        this.answersTemp.crossword.push([])
        for (let j = 0; j < this.answersTemp.w; j++) {
          this.answersTemp.crossword[i].push('')
        }
      }
    },

    handleRemoveMatchingAnswerItem(index) {
      if (
        this.answersTemp &&
        this.answersTemp.classificationFields &&
        index < this.rightTemp.length
      ) {
        this.answersTemp.classificationFields.splice(index, 1)
        this.rightTemp.splice(index, 1)

        this.updateAnswersToParent()
        this.updateRightAnswerToParent()
      }
    },

    handleAddMultiMatchingPoolItem() {
      if (!this.answersTemp || typeof this.answersTemp !== 'object' || Array.isArray(this.answersTemp)) {
        this.answersTemp = { list: [], classificationFields: [] }
      } else if (!this.answersTemp.list) {
        this.$set(this.answersTemp, 'list', [])
      }
      this.answersTemp.list.push('')
      this.updateAnswersToParent()
    },
    handleRemoveMultiMatchingPoolItem(index) {
      this.answersTemp.list.splice(index, 1)
      this.updateAnswersToParent()
      for (let i = 0; i < this.rightTemp.length; i++) {
        if (this.rightTemp[i] === index) {
          this.$set(this.rightTemp, i, undefined)
        } else if (this.rightTemp[i] > index) {
          this.$set(this.rightTemp, i, this.rightTemp[i] - 1)
        }
      }
      this.updateRightAnswerToParent()
    },
    handleAddMultiMatchingTargetItem() {
      if (!this.answersTemp || typeof this.answersTemp !== 'object' || Array.isArray(this.answersTemp)) {
        this.answersTemp = { list: [], classificationFields: [] }
      } else if (!this.answersTemp.classificationFields) {
        this.$set(this.answersTemp, 'classificationFields', [])
      }
      this.answersTemp.classificationFields.push('')
      if (!Array.isArray(this.rightTemp)) {
        this.rightTemp = []
      }
      this.rightTemp.push(undefined)
      this.updateAnswersToParent()
      this.updateRightAnswerToParent()
    },
    handleRemoveMultiMatchingTargetItem(index) {
      this.answersTemp.classificationFields.splice(index, 1)
      this.rightTemp.splice(index, 1)
      this.updateAnswersToParent()
      this.updateRightAnswerToParent()
    },

    handleAddMatchingAnswerItem() {
      if (this.answersTemp && this.answersTemp.classificationFields) {
        this.answersTemp.classificationFields.push('')
        this.rightTemp.push('')

        this.updateAnswersToParent()
        this.updateRightAnswerToParent()
      }
    },

    handleSelectUnderlineWordTag(rightIndex) {
      const index = _.findIndex(this.rightTemp, (v) => {
        return v === rightIndex
      })

      if (index !== -1) {
        this.rightTemp.splice(index, 1)
      } else {
        this.rightTemp.push(rightIndex)
        this.rightTemp = this.rightTemp.sort()
      }

      this.updateRightAnswerToParent()
    },

    handleUpdateUnderlineWordAnswer(field) {
      if (['underlineType', 'underlinePhrase'].includes(field)) {
        this.rightTemp = []
      }

      this.updateAnswersToParent()
      this.updateRightAnswerToParent()
    },

    handleUpdateClassificationAnswer(field) {
      if (['classificationFields', 'classificationList'].includes(field)) {
        this.rightTemp = []
      }

      this.updateAnswersToParent()
      this.updateRightAnswerToParent()
    },

    handleMultiSelectChange(index, checked) {
      if (!this.rightTemp || typeof this.rightTemp !== 'object') {
        this.rightTemp = {}
      }

      this.$set(this.rightTemp, index, checked)
      this.updateRightAnswerToParent()
    },

    deleteAnswerItem(index) {
      this.answersTemp.splice(index, 1)

      // Reset rightTemp based on question type
      if (this.questionType === 'MultiSelect') {
        // Remove the deleted index and shift higher indices down
        const newRightTemp = {}
        Object.keys(this.rightTemp).forEach((key) => {
          const idx = parseInt(key)
          if (idx < index) {
            // Keep lower indices as is
            newRightTemp[idx] = this.rightTemp[key]
          } else if (idx > index) {
            // Shift higher indices down by 1
            newRightTemp[idx - 1] = this.rightTemp[key]
          }
          // Skip the deleted index
        })
        this.rightTemp = newRightTemp
      } else {
        this.rightTemp = ''
      }

      this.updateAnswersToParent()
      this.updateRightAnswerToParent()
    },

    deleteRightAnswerItem(index) {
      this.rightTemp.splice(index, 1)
      this.updateRightAnswerToParent()
    },

    addAnswerItem() {
      this.answersTemp.push('')
      this.updateAnswersToParent()
    },

    addRightAnswerItem() {
      this.rightTemp.push('')
      this.updateRightAnswerToParent()
    },

    updateAnswersToParent() {
      this.$emit('updateAnswer', this.questionType, this.answersTemp)
    },

    updateFakeChoiceToParent() {
      this.$emit(
        'updateFakeChoiceToParent',
        this.questionType,
        this.fakeChoicesTemp
      )
    },

    updateRightAnswerToParent() {
      let rightValue = this.rightTemp

      // Convert object to array for MultiSelect
      if (
        this.questionType === 'MultiSelect' &&
        this.rightTemp &&
        typeof this.rightTemp === 'object' &&
        !Array.isArray(this.rightTemp)
      ) {
        rightValue = Object.keys(this.rightTemp)
          .filter((key) => this.rightTemp[key] === true)
          .map((key) => parseInt(key))
      }

      this.$emit('updateRightAnswer', this.questionType, rightValue)
    },

    async handleUpload(field, key, index, files) {
      if (this.config.storageClass === 1) {
        await this.$store.dispatch('media/GetSharedLink', {
          fileId: files.id,
          accessToken: this.googleDrive.accessToken
        })
        const fileId = files.id + '&ggdrive'
        if (field === 'answersTemp') {
          this.$set(this[field][key], index, fileId)
        } else {
          this.$set(this[field], index, fileId)
        }
        this.updateAnswersToParent()
        this.updateRightAnswerToParent()
        return
      }

      if (files.length > 0) {
        await this.uploadAttachment(files[0], field, key, index)
      }
    },

    async uploadAttachment(file, field, key, index) {
      if (this.uploadLoading[field][key.toString()]) {
        this.$notify({
          type: 'warning',
          title: 'Lỗi',
          message: 'Vui lòng đợi tải lên các tập tin trước đó hoàn tất.'
        })

        return
      }

      if (!this.examVaultId) {
        this.$notify({
          type: 'warning',
          title: 'Lỗi',
          message: 'Vui lòng chọn đề thi trước khi tải lên tập tin.'
        })

        return
      }

      this.$set(this.uploadLoading[field], index.toString(), true)

      try {
        const response = await examVaultApi.uploadAttachment({
          file,
          examVaultId: this.examVaultId
        })

        if (field === 'answersTemp') {
          this.$set(this[field][key], index, '/' + response.data.key)
        } else {
          this.$set(this[field], index, '/' + response.data.key)
        }

        this.updateAnswersToParent()
        this.updateRightAnswerToParent()
      } catch (error) {
        console.error(error)
      }

      this.$set(this.uploadLoading[field], index.toString(), false)
    },

    clearFile(field, key, index) {
      if (field === 'answersTemp') {
        this.$set(this[field][key], index, null)
      } else {
        this.$set(this[field], index, null)
      }
    },

    // ============================================
    // DaDImageLabeling methods
    // ============================================
    handleShowDadLabelDialog(index = -1) {
      this.dadLabelEditIndex = index
      if (index >= 0 && this.rightTemp[index]) {
        this.dadLabelForm = { ...this.rightTemp[index] }
      } else {
        this.dadLabelForm = {
          label: '',
          x: 0,
          y: 0,
          w: 0,
          h: 0
        }
      }
      this.dadLabelDialogVisible = true
    },

    handleSaveDadLabel() {
      if (!this.dadLabelForm.label) {
        this.$notify({
          type: 'warning',
          title: 'Lỗi',
          message: 'Vui lòng nhập tên nhãn.'
        })
        return
      }

      if (!Array.isArray(this.rightTemp)) {
        this.rightTemp = []
      }

      if (this.dadLabelEditIndex >= 0) {
        this.$set(this.rightTemp, this.dadLabelEditIndex, {
          ...this.dadLabelForm
        })
      } else {
        this.rightTemp.push({ ...this.dadLabelForm })
      }

      this.updateRightAnswerToParent()
      this.dadLabelDialogVisible = false
    },

    handleDeleteDadLabel(index) {
      if (index > -1 && index < this.rightTemp.length) {
        this.rightTemp.splice(index, 1)
        this.updateRightAnswerToParent()
      }
    },

    handleImageMouseDown(e) {
      e.preventDefault()
      const rect = e.currentTarget.getBoundingClientRect()
      const x = ((e.clientX - rect.left) / rect.width) * 100
      const y = ((e.clientY - rect.top) / rect.height) * 100

      this.isDrawing = true
      this.drawStart = { x, y }
      this.dadLabelForm.x = Math.round(x)
      this.dadLabelForm.y = Math.round(y)
      this.dadLabelForm.w = 1
      this.dadLabelForm.h = 1
    },

    handleImageMouseMove(e) {
      if (!this.isDrawing) return

      e.preventDefault()
      const rect = e.currentTarget.getBoundingClientRect()
      const x = ((e.clientX - rect.left) / rect.width) * 100
      const y = ((e.clientY - rect.top) / rect.height) * 100

      const startX = Math.min(this.drawStart.x, x)
      const startY = Math.min(this.drawStart.y, y)
      const w = Math.abs(x - this.drawStart.x)
      const h = Math.abs(y - this.drawStart.y)

      this.dadLabelForm.x = Math.round(Math.max(0, Math.min(100, startX)))
      this.dadLabelForm.y = Math.round(Math.max(0, Math.min(100, startY)))
      this.dadLabelForm.w = Math.round(
        Math.max(1, Math.min(100 - this.dadLabelForm.x, w))
      )
      this.dadLabelForm.h = Math.round(
        Math.max(1, Math.min(100 - this.dadLabelForm.y, h))
      )
    },

    handleImageMouseUp() {
      this.isDrawing = false
    },

    // ============================================
    // FillInTheBlanks methods
    // ============================================
    handleSaveCursorPosition() {
      const textarea =
        this.$refs.fillBlanksTextRef?.$el?.querySelector('textarea')
      if (textarea) {
        this.fillBlanksCursorPos = {
          start: textarea.selectionStart,
          end: textarea.selectionEnd
        }
      }
    },

    handleInsertBlank() {
      if (this.preview) return

      const text = this.answersTemp || ''
      const start = this.fillBlanksCursorPos?.start ?? text.length
      const end = this.fillBlanksCursorPos?.end ?? text.length
      const newText = text.substring(0, start) + '[[]]' + text.substring(end)
      this.answersTemp = newText
      this.syncFillBlanksAnswerKey()
      this.updateAnswersToParent()

      this.fillBlanksCursorPos = { start: start + 4, end: start + 4 }

      this.$nextTick(() => {
        const textarea =
          this.$refs.fillBlanksTextRef?.$el?.querySelector('textarea')
        if (textarea) {
          textarea.focus()
          textarea.setSelectionRange(start + 4, start + 4)
        }
      })
    },

    handleInsertNewLine() {
      if (this.preview) return

      const text = this.answersTemp || ''
      const start = this.fillBlanksCursorPos?.start ?? text.length
      const end = this.fillBlanksCursorPos?.end ?? text.length
      const newText = text.substring(0, start) + ' |n| ' + text.substring(end)
      this.answersTemp = newText
      this.updateAnswersToParent()

      this.fillBlanksCursorPos = { start: start + 5, end: start + 5 }

      this.$nextTick(() => {
        const textarea =
          this.$refs.fillBlanksTextRef?.$el?.querySelector('textarea')
        if (textarea) {
          textarea.focus()
          textarea.setSelectionRange(start + 5, start + 5)
        }
      })
    },

    syncFillBlanksAnswerKey() {
      const text = this.answersTemp || ''
      const blankCount = (text.match(/\[\[\]\]/g) || []).length

      if (!Array.isArray(this.rightTemp)) {
        this.rightTemp = []
      }

      while (this.rightTemp.length < blankCount) {
        this.rightTemp.push([])
      }
      while (this.rightTemp.length > blankCount) {
        this.rightTemp.pop()
      }

      this.updateRightAnswerToParent()
    },

    handleFillBlanksTextChange() {
      this.syncFillBlanksAnswerKey()
      this.updateAnswersToParent()
    },

    handleUpdateBlankAnswer(blankIndex, answers) {
      if (!Array.isArray(this.rightTemp)) {
        this.rightTemp = []
      }
      this.$set(this.rightTemp, blankIndex, answers)
      this.updateRightAnswerToParent()
    },

    handleDeleteBlank(globalBlankIndex) {
      const text = this.answersTemp || ''
      const blanks = text.match(/\[\[\]\]/g) || []

      if (globalBlankIndex < 0 || globalBlankIndex >= blanks.length) return

      let count = 0
      const newText = text.replace(/\[\[\]\]/g, (match) => {
        if (count === globalBlankIndex) {
          count++
          return ''
        }
        count++
        return match
      })

      this.answersTemp = newText
      this.syncFillBlanksAnswerKey()
      this.updateAnswersToParent()
    },

    getGlobalBlankIndex(lineIndex, partIndex) {
      const text = this.answersTemp || ''
      const lines = text.split(/\s*\|n\|\s*/)
      let globalBlankIndex = 0

      for (let i = 0; i < lineIndex; i++) {
        const blanksInLine = (lines[i].match(/\[\[\]\]/g) || []).length
        globalBlankIndex += blanksInLine
      }
      globalBlankIndex += partIndex

      return globalBlankIndex
    },

    getFillBlanksPreviewParts() {
      const text = this.answersTemp || ''
      const lines = text.split(/\s*\|n\|\s*/)
      return lines.map((line) => {
        const parts = line.split(/\[\[\]\]/)
        return parts
      })
    },

    getBlankAnswerDisplay(lineIndex, partIndex) {
      const text = this.answersTemp || ''
      const lines = text.split(/\s*\|n\|\s*/)
      let globalBlankIndex = 0

      for (let i = 0; i < lineIndex; i++) {
        const blanksInLine = (lines[i].match(/\[\[\]\]/g) || []).length
        globalBlankIndex += blanksInLine
      }
      globalBlankIndex += partIndex

      const answers = this.rightTemp?.[globalBlankIndex]
      if (answers && answers.length > 0) {
        return answers.join(' / ')
      }
      return '________'
    }
  }
}
</script>

<style lang="scss" scoped>
.question-answer {
  padding-top: 12px;
  .add-btn {
    display: flex;
    align-items: center;
    color: #1cab36;
    cursor: pointer;
    padding-bottom: 12px;

    .label {
      font-weight: bold;
    }

    .add-circle {
      padding: 0px;
      background: #1cab36;
      border-radius: 50%;
      margin-right: 8px;
      .md-icon {
        color: #fff;
      }
    }
  }

  .answer-item {
    display: flex;
    align-items: center;
    padding-bottom: 14px;
    .md-radio {
      margin: 0px 16px 0px 0;
      display: flex;
      align-items: center;
    }

    .tag-list {
      margin-right: 20px;
    }

    .classification-tag {
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      background: #fff;
      padding: 0 12px;
      height: 42px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      white-space: nowrap;
    }

    .underline-tag {
      cursor: pointer;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      background: #fff;
      padding: 0 12px;
      height: 34px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      margin-right: 8px;
    }

    .underline-tag.selected {
      background: #1cab36;
      color: #fff;
    }
  }

  .matching {
    .col-header {
      padding-top: 12px;
      font-weight: bold;
    }
  }

  .word-search {
    .crossword-row {
      display: flex;
      justify-content: center;
      .crossword-unit {
        width: 50px;
        height: 50px;
      }
    }
  }

  .complete-sentence {
    .tag-list {
      display: flex;
      flex-wrap: wrap;

      .classification-tag {
        margin-right: 5px;
        margin-top: 5px;
        cursor: pointer;
      }
    }

    .list-answer {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }

    .list-answer-item {
      display: flex;
      flex-wrap: wrap;
      padding-top: 12px;

      .classification-tag {
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        background: #fff;
        padding: 0 12px;
        height: 42px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        white-space: nowrap;
        cursor: pointer;
      }
    }
  }
}

.complete-sentence-tag {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  background: #fff;
  padding: 0 12px;
  height: 42px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  white-space: nowrap;
}

/* ============================================ */
/* DaDImageLabeling Styles */
/* ============================================ */
.dad-image-labeling {
  .dad-image-container {
    margin-bottom: 16px;
    text-align: center;

    .image-wrapper {
      position: relative;
      display: inline-block;
      max-width: 100%;

      .dad-image {
        max-width: 100%;
        max-height: 500px;
        display: block;
      }

      .label-rect {
        position: absolute;
        border: 2px solid #1890ff;
        background: rgba(24, 144, 255, 0.2);
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .label-text {
          background: #1890ff;
          color: #fff;
          padding: 2px 8px;
          font-size: 12px;
          font-weight: bold;
          border-radius: 3px;
          white-space: nowrap;
        }

        .label-actions {
          position: absolute;
          top: 0;
          right: 0;
          display: none;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 4px;
          padding: 2px;

          .el-button {
            padding: 0 4px;
            height: 20px;
          }
        }

        &:hover .label-actions {
          display: flex;
        }
      }
    }
  }
}

/* ============================================ */
/* FillInTheBlanks Styles */
/* ============================================ */
.fill-in-blanks {
  .fill-blanks-editor {
    .toolbar {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }

    .editor-split {
      display: flex;
      gap: 16px;
      margin-bottom: 16px;

      .editor-left {
        flex: 1;

        .section-title {
          font-weight: bold;
          margin-bottom: 8px;
          color: #666;
        }
      }

      .editor-right {
        flex: 1;

        .section-title {
          font-weight: bold;
          margin-bottom: 8px;
          color: #666;
        }

        .preview-content {
          border: 1px solid #d9d9d9;
          border-radius: 4px;
          padding: 12px;
          min-height: 140px;
          background: #fafafa;

          .preview-line {
            margin-bottom: 8px;
            line-height: 2;

            .text-part {
              color: #333;
            }

            .blank-slot {
              display: inline-flex;
              align-items: center;
              gap: 4px;
              min-width: 60px;
              padding: 2px 8px;
              margin: 0 4px;
              background: #e6f7ff;
              border: 1px dashed #1890ff;
              border-radius: 4px;
              color: #1890ff;
              font-weight: 500;

              .blank-number {
                background: #1890ff;
                color: #fff;
                padding: 0 6px;
                border-radius: 3px;
                font-size: 12px;
              }

              .delete-blank-btn {
                padding: 0 2px;
                height: 18px;
                line-height: 1;

                .svg-icon {
                  color: #ff4d4f;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }

    .blanks-answers {
      padding: 12px;
      background: #f5f5f5;
      border-radius: 4px;

      .blanks-title {
        font-weight: bold;
        margin-bottom: 12px;
        color: #1890ff;
      }

      .blank-answer-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .blank-label {
          min-width: 100px;
          font-weight: 500;
          color: #666;
        }
      }
    }
  }

  .fill-blanks-preview {
    .preview-line {
      margin-bottom: 8px;
      line-height: 2;

      .text-part {
        color: #333;
      }

      .blank-slot {
        display: inline-block;
        min-width: 80px;
        padding: 2px 12px;
        margin: 0 4px;
        background: #e6f7ff;
        border: 1px dashed #1890ff;
        border-radius: 4px;
        color: #1890ff;
        font-weight: 500;
        text-align: center;
      }
    }
  }
}
</style>

<style lang="scss">
/* Dialog styles for DaDImageLabeling - not scoped because modal renders in body */
.dad-label-dialog {
  .dialog-image-container {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    max-height: 450px;
    overflow-y: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;

    .dialog-image-wrapper {
      position: relative;
      display: inline-block;
      cursor: crosshair;
      user-select: none;
      max-width: 100%;

      .dialog-image {
        max-width: 100%;
        max-height: 400px;
        display: block;
        pointer-events: none;
      }

      .other-label-rect {
        position: absolute;
        border: 2px solid #1890ff;
        background: rgba(24, 144, 255, 0.2);
        pointer-events: none;
        box-sizing: border-box;
        z-index: 5;

        &.current-editing {
          border-color: #52c41a;
          background: rgba(82, 196, 26, 0.2);
        }

        .other-label-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #1890ff;
          color: #fff;
          padding: 2px 8px;
          font-size: 11px;
          font-weight: bold;
          border-radius: 3px;
          white-space: nowrap;
        }
      }

      .selection-rect {
        position: absolute;
        border: 3px solid #ff4d4f;
        background: rgba(255, 77, 79, 0.35);
        pointer-events: none;
        box-sizing: border-box;
        z-index: 10;
      }
    }
  }

  .no-image-notice {
    padding: 20px 0;
  }
}
</style>
